function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#000",
  d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z"
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FF5A00",
  d: "M9 8h6v8H9z"
}), React.createElement("path", {
  fill: "#EB001B",
  d: "M10.119 12c0-1.532.693-2.98 1.881-3.93a4.9 4.9 0 0 0-5.861-.187 5.03 5.03 0 0 0-1.914 5.606C4.87 15.58 6.785 17.003 8.95 17c1.107 0 2.18-.376 3.049-1.07a5.035 5.035 0 0 1-1.88-3.93z"
}), React.createElement("path", {
  fill: "#F79E1B",
  d: "M20 12a5.01 5.01 0 0 1-2.785 4.496A4.902 4.902 0 0 1 12 15.935 5.038 5.038 0 0 0 13.883 12 5.038 5.038 0 0 0 12 8.065a4.902 4.902 0 0 1 5.215-.561A5.01 5.01 0 0 1 20 12z"
})));

var SvgMastercard = function SvgMastercard(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgMastercard;